// import {useEffect, useState} from "react";
import {generateArray} from "../../../../utils/array-helper";
import {ConfettiContainerBox} from "./boxes/confetti-container.box";
import {MAX_CONFETTI_PIECES} from "./boxes/confetti-props";
import {ConfettiStripsSvgPathBox} from "./boxes/confetti-strips-svg-path.box";
import {ConfettiStripsSvgBox} from "./boxes/confetti-strips-svg.box";
import {ConfettiBox} from "./boxes/confetti.box";
import {ConfettiZIndex} from "./confetti.component.interface";

// SVG object paths - count 5
const pathDValues = [
    'M494.501 399.5C539.001 384.833 636.401 330.6 670.001 231C712.001 106.5 665.001 97 753.501 43C842.001 -11 778.501 109.5 739.501 94.5C700.501 79.5 823.501 -51.5 659.001 35.5M494.501 495C591.501 567.5 584.737 748.411 688.109 740.5C786.109 733 764.501 623 678.001 623C608.108 623 577.001 753 624.501 854.5',
    'M511.501 442C626 477.5 891.628 288 994 289.5C1106 289.5 922.355 434.515 882 374.5C843 316.5 969.5 135 1072 197.5M387.5 399.5C346.5 365 192.9 402.1 226.5 302.5C268.5 178 32.8934 353 129 353C210.5 353 103.5 264.5 85.5002 215C71.1471 175.528 85.5002 83 3 170.5',
    'M387.5 495C386.5 520.667 154.6 728 72.9999 754C-29.0001 786.5 115 586 141.5 656C181.928 762.79 34.4898 836.821 72.9999 872.5C107 904 232.5 862.5 146.5 821',
];
  
interface IConfettiComponentProps {
    coordinates?: {left: number; top: number;};
    /**
     * Normally we wouldn't need a property to start, we would just render the component if we need to show the confetti
     * But rendering the confetti with display: none and triggering the animation with display: unset / initial / block; seems to help with performance
     * We don't need to alter display on all animated elements, changing just the container box is enough
     */
    zIndex?: number | ConfettiZIndex;
    animate: boolean;
}

export const ConfettiComponent: React.FC<IConfettiComponentProps> = (props) => {
    const confettiCount = MAX_CONFETTI_PIECES;

    return <ConfettiContainerBox animate={props.animate} zIndex={props.zIndex}>
        {generateArray(confettiCount).map((value, idx) => // value is 1 based, idx is 0 based
            <ConfettiBox
                key={value}
                className="confetti"
                confettiIndex={value}
                startCoordinates={props.coordinates}
                style={{
                    animationDelay: ((idx % 6) * 0.2) + "s"
                }}
            />
        )}
        <ConfettiStripsSvgBox
            fill="none"
            className="confetti-svg"
            viewBox="0 0 1075 891"
            xmlns="http://www.w3.org/2000/svg"
            startCoordinates={props.coordinates}
        >
            {pathDValues.map((d, i) => {
                return <ConfettiStripsSvgPathBox
                    key={i} d={d}
                    confettiStripIndex={i}
                />;
            })}
        </ConfettiStripsSvgBox>
    </ConfettiContainerBox>;
}